export const FormSummaryConstants = {
  PAGE_MARGIN: 15, // Default 15
  HEADER_FONT_SIZE: 14, // Default 14
  FONT_SIZE: 10, // Default 10
  NOTES_FONT_SIZE: 8, // Default 7
  NUMBERING_WIDTH: 7, // Default 7
  LINE_HEIGHT: 0.45, // Default 0.45
  QUESTION_GAP: 5, // Default 3
  NOTES_FONT_COLOR: '#858585', // Default
};

export const RiskControlFormConstants = {
  PAGE_MARGIN: 20, // Default 20
  HEADER_FONT_SIZE: 14, // Default 14
  FONT_SIZE: 10, // Default 10
  NOTES_FONT_SIZE: 8, // Default 7
  NUMBERING_WIDTH: 7, // Default 7
  LINE_HEIGHT: 0.45, // Default 0.45
  QUESTION_GAP: 7, // Default 7
  NOTES_FONT_COLOR: '#858585', // Default
};
